import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material";
import { FormService } from "src/app/services/form.service";
declare var jQuery: any;
declare var $: any;
@Component({
  selector: "app-normas-agrupamiento",
  templateUrl: "./normas-agrupamiento.component.html",
  styleUrls: ["./normas-agrupamiento.component.css"],
  providers: [FormService],
})
export class NormasAgrupamientoComponent implements OnInit {
  @ViewChild("openModal") openModal: TemplateRef<any>;
  public rows = [];
  public actualRow;
  form: FormGroup;
  numerosPermisoAnteriores: number[] = [];
  public Permiso_Anteriores;
  public Recepcion_Anteriores;
  public Numero_Permiso_Anteriores;
  public Edificacion_Permiso1;
  public Edificacion_Regularizada1;
  public Edificacion_Permiso2;
  public Edificacion_Regularizada2;
  public Edificacion_Permiso3;
  public Edificacion_Regularizada3;
  public Edificacion_Permiso_Total;
  public Edificacion_Regularizada_Total;
  public Total_Regularizar;
  public Total_Edificar_Predio;
  public Total_Predio;
  public Tipo_Agrupamiento;
  public Norma_Complementaria;
  public Altura_Minima;
  public Medida_Minima;
  public Terminacion_Interior;
  public Ventilacion;
  public Resistencia_Fuego_Edificio;
  public Resistencia_Fuego_Adosamiento;
  public Norma_Seguridad;
  public Norma_estabilidad;
  public Establecimiento;
  public formulario;
  public form1303 = false;
  public form1301 = false;

  constructor(private fb: FormBuilder, private dialog: MatDialog) {
    this.formulario = localStorage.getItem("form");

    if (this.formulario == "13.1") {
      this.form1301 = true;
    }
    if (this.formulario == "13.3") {
      this.form1303 = true;
    }

    this.form = this.fb.group({
      Establecimiento: new FormControl(""),
      Permiso_Anteriores: new FormControl(""),
      Recepcion_Anteriores: new FormControl(""),
      Numero_Permiso_Anteriores: new FormControl(""),
      Edificacion_Permiso1: new FormControl(""),
      Edificacion_Regularizada1: new FormControl(""),
      Edificacion_Permiso2: new FormControl(""),
      Edificacion_Regularizada2: new FormControl(""),
      Edificacion_Permiso3: new FormControl(""),
      Edificacion_Regularizada3: new FormControl(""),
      Edificacion_Permiso_Total: new FormControl(""),
      Edificacion_Regularizada_Total: new FormControl(""),
      Total_Regularizar: new FormControl(""),
      Total_Edificar_Predio: new FormControl(""),
      Total_Predio: new FormControl(""),
      Tipo_Agrupamiento: new FormControl(""),
      Norma_Complementaria: new FormControl(""),
      Altura_Minima: new FormControl(""),
      Medida_Minima: new FormControl(""),
      Terminacion_Interior: new FormControl(""),
      Ventilacion: new FormControl(""),
      Resistencia_Fuego_Edificio: new FormControl(""),
      Resistencia_Fuego_Adosamiento: new FormControl(""),
      Norma_Seguridad: new FormControl(""),
      Norma_estabilidad: new FormControl(""),
    });
    if (!JSON.parse(localStorage.getItem("normas_agrupamiento"))) {
      localStorage.setItem("normas_agrupamiento", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("normas_agrupamiento"));
      this.form.controls["Establecimiento"].setValue(
        this.rows[0] ? this.rows[0].Establecimiento: ""
      );
      this.form.controls["Permiso_Anteriores"].setValue(
        this.rows[0] ? this.rows[0].Permiso_Anteriores : ""
      );
      this.form.controls["Recepcion_Anteriores"].setValue(
        this.rows[0] ? this.rows[0].Recepcion_Anteriores : ""
      );
      this.form.controls["Numero_Permiso_Anteriores"].setValue(
        this.rows[0] ? this.rows[0].Numero_Permiso_Anteriores : ""
      );
      this.form.controls["Edificacion_Permiso1"].setValue(
        this.rows[0] ? this.rows[0].Edificacion_Permiso1 : ""
      );
      this.form.controls["Edificacion_Regularizada1"].setValue(
        this.rows[0] ? this.rows[0].Edificacion_Regularizada1 : ""
      );
      this.form.controls["Edificacion_Permiso2"].setValue(
        this.rows[0] ? this.rows[0].Edificacion_Permiso2 : ""
      );
      this.form.controls["Edificacion_Regularizada2"].setValue(
        this.rows[0] ? this.rows[0].Edificacion_Regularizada2 : ""
      );
      this.form.controls["Edificacion_Permiso3"].setValue(
        this.rows[0] ? this.rows[0].Edificacion_Permiso3 : ""
      );
      this.form.controls["Edificacion_Regularizada3"].setValue(
        this.rows[0] ? this.rows[0].Edificacion_Regularizada3 : ""
      );
      this.form.controls["Edificacion_Permiso_Total"].setValue(
        this.rows[0] ? this.rows[0].Edificacion_Permiso_Total : ""
      );
      this.form.controls["Edificacion_Regularizada_Total"].setValue(
        this.rows[0] ? this.rows[0].Edificacion_Regularizada_Total : ""
      );
      this.form.controls["Total_Regularizar"].setValue(
        this.rows[0] ? this.rows[0].Total_Regularizar : ""
      );
      this.form.controls["Total_Edificar_Predio"].setValue(
        this.rows[0] ? this.rows[0].Total_Edificar_Predio : ""
      );
      this.form.controls["Total_Predio"].setValue(
        this.rows[0] ? this.rows[0].Total_Predio : ""
      );
      this.form.controls["Tipo_Agrupamiento"].setValue(
        this.rows[0] ? this.rows[0].Tipo_Agrupamiento : ""
      );
      this.form.controls["Norma_Complementaria"].setValue(
        this.rows[0] ? this.rows[0].Norma_Complementaria : ""
      );
      this.form.controls["Altura_Minima"].setValue(
        this.rows[0] ? this.rows[0].Altura_Minima : ""
      );
      this.form.controls["Medida_Minima"].setValue(
        this.rows[0] ? this.rows[0].Medida_Minima : ""
      );
      this.form.controls["Terminacion_Interior"].setValue(
        this.rows[0] ? this.rows[0].Terminacion_Interior : ""
      );
      this.form.controls["Ventilacion"].setValue(
        this.rows[0] ? this.rows[0].Ventilacion : ""
      );
      this.form.controls["Resistencia_Fuego_Edificio"].setValue(
        this.rows[0] ? this.rows[0].Resistencia_Fuego_Edificio : ""
      );
      this.form.controls["Resistencia_Fuego_Adosamiento"].setValue(
        this.rows[0] ? this.rows[0].Resistencia_Fuego_Adosamiento : ""
      );
      this.form.controls["Norma_Seguridad"].setValue(
        this.rows[0] ? this.rows[0].Norma_Seguridad : ""
      );
      this.form.controls["Norma_estabilidad"].setValue(
        this.rows[0] ? this.rows[0].Norma_estabilidad : ""
      );
    }
  }

  ngOnInit() {
    this.loadNumerosPermisoAnteriores();
  }

  add_normas_Agrupamiento() {
    localStorage.setItem("normas_agrupamiento", JSON.stringify([]));
    this.actualRow = localStorage.getItem("normas_agrupamiento");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      Establecimiento: this.form.value.Establecimiento, 
      Permiso_Anteriores:
        this.form.value.Permiso_Anteriores === "SI" ? "SI" : "NO",
      Recepcion_Anteriores:
        this.form.value.Recepcion_Anteriores === "SI" ? "SI" : "NO",
      Numero_Permiso_Anteriores: this.form.value.Numero_Permiso_Anteriores,
      Edificacion_Permiso1: this.form.value.Edificacion_Permiso1,
      Edificacion_Regularizada1: this.form.value.Edificacion_Regularizada1,
      Edificacion_Permiso2: this.form.value.Edificacion_Permiso2,
      Edificacion_Regularizada2: this.form.value.Edificacion_Regularizada2,
      Edificacion_Permiso3: this.form.value.Edificacion_Permiso3,
      Edificacion_Regularizada3: this.form.value.Edificacion_Regularizada3,
      Edificacion_Permiso_Total: this.form.value.Edificacion_Permiso_Total,
      Edificacion_Regularizada_Total:
        this.form.value.Edificacion_Regularizada_Total,
      Total_Regularizar: this.form.value.Total_Regularizar,
      Total_Edificar_Predio: this.form.value.Total_Edificar_Predio,
      Total_Predio: this.form.value.Total_Predio,
      Tipo_Agrupamiento: this.form.value.Tipo_Agrupamiento,
      Norma_Complementaria: this.form.value.Norma_Complementaria,
      Altura_Minima: this.form.value.Altura_Minima,
      Medida_Minima: this.form.value.Medida_Minima,
      Terminacion_Interior: this.form.value.Terminacion_Interior,
      Ventilacion: this.form.value.Ventilacion,
      Resistencia_Fuego_Edificio: this.form.value.Resistencia_Fuego_Edificio,
      Resistencia_Fuego_Adosamiento:
        this.form.value.Resistencia_Fuego_Adosamiento,
      Norma_Seguridad: this.form.value.Norma_Seguridad,
      Norma_estabilidad: this.form.value.Norma_estabilidad,
    });
    localStorage.setItem("normas_agrupamiento", JSON.stringify(this.rows));
  }

  delete_normas_Agrupamiento(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("normas_agrupamiento", JSON.stringify(this.rows));
      }
    }
  }

  agregarNumero() {
    const numeroInput = this.form.controls["Numero_Permiso_Anteriores"];
    const numero = parseInt(numeroInput.value);

    if (
      !isNaN(numero) &&
      !this.numerosPermisoAnteriores.includes(numero) &&
      this.numerosPermisoAnteriores.length < 3
    ) {
      this.numerosPermisoAnteriores.push(numero);
      this.saveNumerosPermisoAnteriores();
      numeroInput.setValue(""); // Borrar el valor del campo
    }
  }

  eliminarNumero(numero: number) {
    const index = this.numerosPermisoAnteriores.indexOf(numero);
    if (index !== -1) {
      this.numerosPermisoAnteriores.splice(index, 1);
      this.saveNumerosPermisoAnteriores();
    }
  }

  saveNumerosPermisoAnteriores() {
    localStorage.setItem(
      "Numero_Permiso_Anteriores",
      JSON.stringify(this.numerosPermisoAnteriores)
    );
    const numerosString = this.numerosPermisoAnteriores.join(",");
    this.form.controls["Numero_Permiso_Anteriores"].setValue(numerosString);
  }

  loadNumerosPermisoAnteriores() {
    const numerosString = localStorage.getItem("Numero_Permiso_Anteriores");
    if (numerosString) {
      this.numerosPermisoAnteriores = JSON.parse(numerosString);
      this.form.controls["Numero_Permiso_Anteriores"].setValue(numerosString);
    }
  }
}
